/**
 * Sticky banner shown when the backend's major API version differs from
 * the one this frontend was built against. Non-dismissable — the SPA is
 * incompatible until refresh.
 */

import { useApiVersionGuard } from '../../hooks/useApiVersionGuard';

export function ApiVersionBanner() {
  const mismatchVersion = useApiVersionGuard();
  if (!mismatchVersion) return null;
  return (
    <div
      role="alert"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        background: 'var(--ember)',
        color: 'var(--ember-ink)',
        padding: '10px 16px',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 600,
        borderBottom: '1px solid var(--ember-deep)',
      }}
    >
      A new version of Eloquor is available (server is on {mismatchVersion}).{' '}
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          background: 'var(--ember-ink)',
          color: 'var(--paper)',
          border: 0,
          borderRadius: 4,
          padding: '4px 10px',
          marginLeft: 8,
          cursor: 'pointer',
          fontWeight: 600,
        }}
      >
        Refresh
      </button>
    </div>
  );
}
